import axios from 'axios'
import config from '../config';

import { getQueryStringFromObject, getRequestHeaders } from './common.service';
import { translate } from '../i18n/customI18nProvider';
import { askInput, formatCurrency, notifyConfirm, notifyError, notifySuccess, request } from '../util';

const findClientInAnyEventByWristbandUID = async (uid) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/clients/findInAnyEvents/' + uid, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const activateClients = async (wristbands, entrance_id, amount, age) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/clients/activateClients', {
                wristbands: wristbands,
                entrance_id: entrance_id,
                amount: amount,
                age: age
            }, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

async function executeRefund(client_uid, tran_id=null, method=null) {
    if(method == null && tran_id == null) {
        notifyError(translate('custom.invalid_refund_method'));
        return;
    }
    
    let refund;
    if(tran_id !== null) {
        refund = await request('/v1/clients/' + client_uid + '/transaction/' + tran_id + '/refund', 'POST', null);
    } else {
        refund = await request('/v1/clients/' + client_uid + '/refund', 'POST', null, {method: method});
    }

    if (refund.error) {
        notifyError(refund.error);
        return;
    }

    if(!refund.success) {
        if(refund.data){
            notifyError(JSON.stringify(refund.data));
        } else {
            notifyError(translate('custom.unable_to_refund'));
        }
    }
    notifySuccess(translate('custom.money_refunded_successfully') + (refund.amount ? " " + formatCurrency(refund.amount) : ""));
}

async function refundTransaction(client_uid, tran_id) {

    let confirmation = await notifyConfirm('custom.do_you_want_to_refund_transaction');
    if(!confirmation.isConfirmed) return;

    await executeRefund(client_uid, tran_id);
}

async function refundClient(client_uid, method) {

    let confirmation = await notifyConfirm('custom.do_you_want_to_refund_client');
    if(!confirmation.isConfirmed) return;

    await executeRefund(client_uid, null, method);
}

async function forceRefundMoney(client_uid) {
    let confirmation = await notifyConfirm('custom.do_you_want_to_force_refund');
    if(!confirmation.isConfirmed) return;

    try {
        let money_refunded = await request('/v1/clients/' + client_uid + "/checkoutforce", 'POST', null, {});
        
        if(money_refunded.error) {
            notifyError(money_refunded.error);
            return;
        }

        if(money_refunded.status != 'success') {
            notifyError(translate('custom.unable_to_refund'));
            return;
        }

        if(money_refunded.amount === 0) {
            notifyError(translate('custom.unable_to_refund') + ". " + translate('custom.balance') + " : " + formatCurrency(money_refunded.amount));
            return;
        }

        notifySuccess(translate('custom.money_refunded_successfully') + " " + translate('custom.amount_to_refund') + " : " + formatCurrency(money_refunded.amount));
    } catch (error) {
        notifyError(translate('custom.unknown_error'));
    }
}

async function refundMoneyByCash(client_uid) {

    let confirmation = await notifyConfirm('custom.do_you_want_to_refund_client_by_cash');
    if(!confirmation.isConfirmed) return;

    let money_refunded = await request('/v1/clients/' + client_uid + "/refundCash", 'POST', null, {});
    
    if(money_refunded.error) {
        notifyError(money_refunded.error);
        return;
    }

    if(money_refunded.status != 'success') {
        notifyError(translate('custom.unable_to_refund'));
        return;
    }

    if(money_refunded.amount === 0) {
        notifyError(translate('custom.unable_to_refund') + ". " + translate('custom.balance') + " : " + formatCurrency(money_refunded.amount));
        return;
    }

    notifySuccess(translate('custom.money_refunded_successfully') + ". " + translate('custom.amount_to_refund') + " : " + formatCurrency(money_refunded.amount));
}

async function addMoney(client_uid, currency = "CHF") {

    const prompt = await askInput('custom.amount', 'custom.amount', 'number');
    if(prompt.isDismissed) return;
    const amount = parseFloat(prompt.value);
    if(Number.isNaN(amount)) {
        notifyError(translate('custom.please_enter_valid_amount'));
        return;
    }

    if(amount <= 0 || amount >= 300) {
        notifyError(translate('custom.please_enter_amount_between') + " " + currency + " 1.- " + translate('custom.and') + " 300.-");
        return;
    }

    let money_added = await request('/v1/clients/' + client_uid + '/credit?channelShort=' + config.channel_types.WEB.short, 'POST', null, {
        type: config.transaction_types.CREDIT,
        amount
    });

    if(money_added.error) {
        notifyError(money_added.error);
        return;
    }

    notifySuccess('custom.money_added_successfully');

}

async function addUnpaidMoney(client_uid, currency) {

    const prompt = await askInput('custom.amount', 'custom.amount', 'number');
    if(prompt.isDismissed) return;
    const amount = parseFloat(prompt.value);
    if(Number.isNaN(amount)) {
        notifyError(translate('custom.please_enter_valid_amount'));
        return;
    }

    if(amount <= 0 || amount >= 300) {
        notifyError(translate('custom.please_enter_amount_between') + " " + currency + " 1.- " + translate('custom.and') + " 300.-");
        return;
    }


    let money_added = await request('/v1/clients/' + client_uid + '/credit?channelShort=' + config.channel_types.WEB.short, 'POST', null, {
        type: config.transaction_types.UNPAID,
        amount
    });

    if(money_added.error) {
        notifyError(money_added.error);
        return;
    }

    notifySuccess('custom.money_added_successfully');
}

async function deleteClient(uid) {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.delete( config.apiUrl + '/v1/clients/' + uid, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

export {
    findClientInAnyEventByWristbandUID,
    activateClients,
    executeRefund,
    refundClient,
    refundTransaction,
    forceRefundMoney,
    refundMoneyByCash,
    addMoney,
    addUnpaidMoney,
    deleteClient
}